/**
 * Date Utilities Module
 * Centralized date and time utilities using dayjs
 *
 * This module provides a consistent API for all date operations across the application.
 * All date operations should go through these utilities instead of using native Date objects.
 */

import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';

// Extend dayjs with required plugins
dayjs.extend(relativeTime);
dayjs.extend(utc);
dayjs.extend(customParseFormat);
dayjs.extend(duration);

// Re-export dayjs for advanced use cases
export { dayjs, type Dayjs };

export * from './calculators';
export * from './comparators';
// Export all utility functions
export * from './formatters';
export * from './parsers';
export * from './timeAgo';
